import React from 'react'
import { useI18n } from 'contexts/i18n'
import { useEntities } from 'state/entities'
import { safeFormat } from 'utilities/date-time'
import { Day, DayHeader, LogEntries } from './s'
import Filter from './filter'
import LogEntry from './entry'
import LoadMore from 'components/load-more'

const salt = 'activity-log'

const ActivityLogContent = () => {
    const {
        locale,
        dateLocale
    } = useI18n()

    const { items } = useEntities()

    const logEntriesByDate = items.reduce((accumulator, entry) => {
        const [date] = new Date(entry.createdDate).toISOString().split('T')

        if(!accumulator[date]) {
            accumulator[date] = []
        }

        accumulator[date].push(entry)
        return accumulator
    }, {})

    const logEntriesByDateEntries = Object.entries(logEntriesByDate)

    const timestampWidth = ['en'].includes(locale) ? '11ch' : '8ch'
    const style = { '--timestamp-width': timestampWidth }

    return (
        <>
            <Filter salt={salt} />
            {logEntriesByDateEntries.map(([date, entries]) => (
                <Day
                    style={style}
                    key={`${salt}:${date}`}>
                    <DayHeader>
                        <time dateTime={safeFormat(date, 'yyyy-MM-dd')}>
                            {safeFormat(date, 'PPP', { locale: dateLocale })}
                        </time>
                    </DayHeader>
                    <LogEntries>
                        {entries.map(entry => (
                            <LogEntry
                                entry={entry}
                                key={entry.id} />
                        ))}
                    </LogEntries>
                </Day>
            ))}
            <LoadMore useItems={useEntities} />
        </>
    )
}

export default ActivityLogContent